import pipefitterApi from '../../../services/pipefitterApi';

export type UpdateProjectSettingsPayload = {
  targetNumberOfPipes?: number | null;
  targetNumberOfPipesEnds?: number | null;
};

export type ProjectSettings = {
  projectNumber?: string;
  projectName?: string;
  targetNumberOfPipes?: number | null;
  targetNumberOfPipesEnds?: number | null;
  [key: string]: unknown;
};

function unwrapData<T>(responseData: any): T {
  if (responseData?.data != null) return responseData.data as T;
  return responseData as T;
}

/**
 * PATCH `/v1/project/:projectNumber/settings`
 */
export async function updateProjectSettings(
  projectNumber: string,
  payload: UpdateProjectSettingsPayload
): Promise<ProjectSettings> {
  const trimmed = projectNumber?.trim();
  if (!trimmed) throw new Error('Project number is required');

  const response = await pipefitterApi.patch(
    `/project/${encodeURIComponent(trimmed)}/settings`,
    payload
  );

  if (response?.data?.status && response.data.status !== 200) {
    throw new Error(response.data.message || 'Failed to update project settings');
  }

  return unwrapData<ProjectSettings>(response.data);
}
